import { render, staticRenderFns } from "./loans.vue?vue&type=template&id=65927eb4&scoped=true"
import script from "./loans.vue?vue&type=script&lang=js"
export * from "./loans.vue?vue&type=script&lang=js"
import style0 from "./loans.vue?vue&type=style&index=0&id=65927eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65927eb4",
  null
  
)

export default component.exports